import { SIDEBAR_VIEWS } from '../../lib/constants'

export default dispatch => ({
  closeSidebar: () => {
    dispatch({
      type: 'app/clearSidebarHistory'
    })
    dispatch({
      type: 'app/setShowSidebar',
      payload: false
    })
    dispatch({
      type: 'app/updateView',
      payload: null
    })
    dispatch({
      type: 'historicalImagery/removeLayers',
      payload: {
        removeWatchHandle: true,
        toggleBasemap: true
      }
    })
    dispatch({
      type: 'map/resetWidgetState'
    })
  },
  collapseSidebar: () => {
    dispatch({
      type: 'app/setShowSidebar',
      payload: false
    })
  },
  navigateBack: sidebarHistoryStack => {
    const sidebarHistory = sidebarHistoryStack[0]
    const itemUuid = sidebarHistory.metadata?.uuid

    switch (sidebarHistory.view) {
      case SIDEBAR_VIEWS.Collection:
        dispatch({
          type: 'collections/setSelectedCollectionLoading',
          payload: true
        })
        dispatch({
          type: 'collections/getSelectedCollection',
          callback: collection => {
            if (collection) {
              dispatch({
                type: 'map/goToExtentOfFeatures',
                payload: collection.featureIds
              })
            } else {
              dispatch({
                type: 'collections/getCollectionEffect',
                payload: itemUuid,
                callback: collection => {
                  if (collection) {
                    dispatch({
                      type: 'collections/setSelectedCollection',
                      payload: collection
                    })
                    dispatch({
                      type: 'map/goToExtentOfFeatures',
                      payload: collection.featureIds
                    })
                  }
                }
              })
            }
            dispatch({
              type: 'collections/setEditingCollection',
              payload: false
            })
            setTimeout(() => {
              dispatch(
                {
                  type: 'collections/setSelectedCollectionLoading',
                  payload: false
                },
                50
              )
            })
          }
        })
        break
      case SIDEBAR_VIEWS.Content:
        if (sidebarHistory.metadata.savedContentTab) {
          const { savedContentTab } = sidebarHistory.metadata
          if (savedContentTab === SIDEBAR_VIEWS.Collection) {
            dispatch({
              type: 'collections/setCollectionsLoading',
              payload: true
            })
            setTimeout(() => {
              dispatch({
                type: 'collections/setCollectionsLoading',
                payload: false
              })
            }, 50)
          } else if (savedContentTab === SIDEBAR_VIEWS.Content) {
            dispatch({
              type: 'features/setFeaturesLoading',
              payload: true
            })
            setTimeout(() => {
              dispatch({
                type: 'features/setFeaturesLoading',
                payload: false
              })
            }, 50)
          }
        }
        break
      case SIDEBAR_VIEWS.FeatureDetail:
        dispatch({
          type: 'features/setSelectedFeatureLoading',
          payload: true
        })
        dispatch({
          type: 'features/getSelectedFeature',
          callback: feature => {
            if (feature) {
              dispatch({
                type: 'map/goToFeature',
                payload: { featureId: feature.uuid }
              })
            } else {
              dispatch({
                type: 'features/getFeature',
                payload: itemUuid,
                callback: feature => {
                  if (feature) {
                    dispatch({
                      type: 'features/setSelectedFeature',
                      payload: feature
                    })
                    dispatch({
                      type: 'map/goToFeature',
                      payload: { featureId: feature.uuid }
                    })
                  }
                }
              })
            }
            // dispatch({
            // 	type: 'features/cancelEditFeature',
            // })
            dispatch({
              type: 'features/setIsEditingFeature',
              payload: false
            })
            dispatch({
              type: 'features/revertFeatureToPreviousState',
              callback: () => {
                dispatch({
                  type: 'features/setPreviousFeatureState',
                  payload: null
                })
              }
            })
            setTimeout(() => {
              dispatch({
                type: 'features/setSelectedFeatureLoading',
                payload: false
              })
            }, 50)
          }
        })
        break
      default:
        break
    }
    dispatch({
      type: 'app/navSidebarBack'
    })
    dispatch({
      type: 'map/resetWidgetState'
    })
  }
})
